import { AccountStatus } from 'mh-client';

export default function useGetStatusLink(
    accountStatus?: AccountStatus | null
): string | null {
    switch (accountStatus?.name) {
        case 'None':
            return null;
        case 'Pending':
        case 'KycDeclined':
        default:
            return '/profile/start-kyc';
        case 'KycVerified':
            return 'profile/bank-details-form';
        case 'Complete':
            return 'funds/MHJP';
    }
}
